import React,{useState} from 'react'
import TextField from '@mui/material/TextField';

const InputComponents = ({value,onChange,name,label,isRequired=false, message, validator,placeholder='',type,disabled}) => {

  const [isNotValid, setIsNotValid] = useState(false)

  const onInputChange = (e)=>{
    onChange(e);
    if(isRequired){
      if(validator){
        console.log(validator(e.target.value),'validate');
        if(validator(e.target.value)){
          setIsNotValid(false);
        }else{
          setIsNotValid(true);
        }
      }else{
        console.log(e.target.value.split('').length!==10,"lenght ");
        if ((name === "contact" ?( e.target.value.length!==10 || Number.isNaN(Number(e.target.value))) :false) || e.target.value ==="" ) {
          setIsNotValid(true);
        }else{
          setIsNotValid(false);
        }
      }
    }
  }

  const onClick = ()=>{
    // onChange(e);
    if(isRequired){
      if(validator){
        if(validator(value)){
          setIsNotValid(false);
        }else{
          setIsNotValid(true);
        }
      }else{
        console.log(value.split('').length!==10,"lenght ");
        if ((name === "contact" ?( value.length!==10 || Number.isNaN(Number(value))) :false) || value ==="" ) {
          setIsNotValid(true);
        }else{
          setIsNotValid(false);
        }
      }
    }
  }

  return (
    <div className='w-full'>
    
        {/* <label htmlFor={name} className='text-primary '>{label}</label> */}
        {/* <input disabled={disabled} onClick={onClick} type={type?type:'text'} placeholder={placeholder} name={name} id={name} className='text-base !bg-transparent' value={value} onChange={(e)=>onInputChange(e)} /> */}
        <TextField
  disabled={disabled}
  type={type ? type : 'text'}
  label={placeholder} // Use `label` instead of `placeholder`
  name={name}
  // id={name}
  id="outlined-basic"
  variant="outlined"
  value={value}
  onChange={(e) => onInputChange(e)}
  fullWidth // Use `fullWidth` for 100% width

/>

    
        {isNotValid &&<p className='text-red-600'>{message?message:name === "contact"? "Please enter 10 digit phone number":`Please add ${label}`}</p>}
    </div>
  )
}

export default InputComponents;